// FormikSelect.tsx
import React from 'react';
import { useField } from 'formik';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  SelectProps,
} from '@mui/material';

export interface Option {
  value: string | number;
  label: React.ReactNode;
}

interface FormikSelectProps extends Omit<SelectProps, 'name'> {
  name: string;
  label: string;
  options: Option[];
  placeholder?: string;
  fullWidth?: boolean;
}

export const FormikSelect: React.FC<FormikSelectProps> = ({
  name,
  label,
  options,
  placeholder,
  fullWidth = true,
  ...props
}) => {
  const [field, meta] = useField(name);
  const isError = Boolean(meta.touched && meta.error);
  const labelId = `${name}-label`;

  return (
    <FormControl fullWidth={fullWidth} error={isError}>
      <InputLabel id={labelId}>{label}</InputLabel>
      <Select
        {...field}
        {...props}
        labelId={labelId}
        label={label}
        value={field.value ?? ''}
      >
        {placeholder && (
          <MenuItem value="">
            <em>{placeholder}</em>
          </MenuItem>
        )}
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
      {isError && <FormHelperText>{meta.error}</FormHelperText>}
    </FormControl>
  );
};